module.exports = __webpack_public_path__ + "media/customizations/meridiana/back-b05f6e8053d81cc2141391342544339e.jpg";